import { COLUMN_NAMES, COLUMN_RESOURCES, Column } from "../../shared";

export const COMPANIES_DESKTOP_TABLE_COLUMNS: Column[] = [
  // Companies page rows content is rendered together with table checkbox in TableCheckbox.tsx
  {
    name: COLUMN_NAMES.Company,
    isSticky: true,
    resource: COLUMN_RESOURCES.Name,
    isDefaultActive: true,
  },
];

export const COMPANIES_MOBILE_TABLE_COLUMNS: Column[] = [
  {
    name: COLUMN_NAMES.Company,
    isSticky: true,
    resource: COLUMN_RESOURCES.Name,
    isDefaultActive: true,
  },
  {
    name: COLUMN_NAMES.ParentCompany,
    isSticky: true,
    resource: COLUMN_RESOURCES.ParentCompanyName,
    isDefaultActive: true,
  },
];

export const COMPANIES_TABLE_COLUMNS = {
  desktop: [
    {
      name: COLUMN_NAMES.Company,
      isSticky: true,
      resource: COLUMN_RESOURCES.Name,
      isDefaultActive: true,
    },
  ] as Column[],
  mobile: [
    {
      name: COLUMN_NAMES.Company,
      isSticky: true,
      resource: COLUMN_RESOURCES.Name,
      isDefaultActive: true,
    },
    {
      name: COLUMN_NAMES.ParentCompany,
      isSticky: true,
      resource: COLUMN_RESOURCES.ParentCompanyName,
      isDefaultActive: true,
    },
  ] as Column[],
};
